import {
  AfterViewInit,
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  Inject,
} from "@angular/core";
import * as langPicker from "./init";

import { APP_CONFIG, AppConfig } from "./language.config";
import { MyEvent } from "./services/myevent.services";
import { Constants } from "./model/constants.models";

@Component({
  selector: "app-language-picker",
  templateUrl: "./language-picker.component.html",
  styleUrls: ["./language-picker.component.scss"],
  // encapsulation: ViewEncapsulation.None
})
export class LanguagePickerComponent implements OnInit, AfterViewInit {
  // mock = [
  //   {
  //     "title": "English",
  //     "code": "en"
  //   },
  //   {
  //     "title": "German",
  //     "code": "de"
  //   },
  //   {
  //     "title": "French",
  //     "code": "fr"
  //   },
  //   {
  //     "title": "Spanish",
  //     "code": "es"
  //   },
  // ];

  //selectedLang = 'en';

  showDropDown = false;

  @ViewChild("languagePicker", { static: true }) languagePicker;

  // new update
  selectedLang;
  languages: Array<{ code: string; name: string }>;

  constructor(
    @Inject(APP_CONFIG) private config: AppConfig,
    private myEvent: MyEvent
  ) {
    this.languages = this.config.availableLanguages;
    this.selectedLang = config.availableLanguages[0].code;
    let defaultLang = window.localStorage.getItem(
      Constants.KEY_DEFAULT_LANGUAGE
    );
    if (defaultLang) this.selectedLang = defaultLang;

    // console.log(this.selectedLang);
    // console.log(defaultLang);
    console.log(this.config);
  }

  ngOnInit(): void {}

  ngAfterViewInit() {}

  onClickedOutside(event) {
    // (event);
    this.showDropDown = false;
  }

  // @HostListener('document:mousedown', ['$event'])
  // onGlobalClick(event): void {

  //    if (!this.languagePicker.nativeElement.contains(event.target)) {
  //      this.showDropDown = false;
  //    }
  // }
  onLanguageClick(language) {
    this.selectedLang = language.code;
    this.languageConfirm();
  }

  languageConfirm() {
    this.myEvent.setLanguageData(this.selectedLang);
    window.localStorage.setItem(
      Constants.KEY_DEFAULT_LANGUAGE,
      this.selectedLang
    );
  }
}
